/* eslint-disable */
import session from './session';

export default {
    getUserList(filter) {
        return session.get(`user/${filter}`);
    },
    getUser(id) {
        return session.get(`user/${id}/`);
    },
    deleteUser(userId) {
        return session.delete(`user/${userId}/`);
    },
    getCurrentUser() {
        return session.get('user/my/');
    },
    createUser(data) {
        return session.post(`user/`, data);
    },
    updateUserData(userId, data) {
        return session.patch(`user/${userId}/`, data );
    },
};